import {
  PATH_HOME,
  PATH_LOGIN,
  PATH_MY_PROFILE,
  PATH_OTP,
  authRoutes,
  enumSubdomain,
} from "@configs";
import { selectApp, selectAuth } from "@redux";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";

export const useRouteGuard = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const token = useSelector(selectAuth)?.auth?.token;
  const { domain } = useSelector(selectApp);

  useEffect(() => {
    const isAuthRoute = authRoutes.includes(pathname);

    if (token && isAuthRoute) {
      history.push(PATH_HOME);
      return;
    }

    if (!token && !isAuthRoute) {
      history.push(PATH_LOGIN);
    }
  }, [token, pathname, history]);

  useEffect(() => {
    if (pathname === PATH_OTP) return;

    const isClinicApp =
      domain === enumSubdomain.CLINIC || domain === enumSubdomain.STG_CLINIC;

    if (isClinicApp && pathname === PATH_HOME) {
      history.push(PATH_MY_PROFILE);
    }
  }, [domain, pathname, history]);
};
